import { isZeusEnvironment } from 'utils/environment'

import { initializeDatadog } from './datadog'
import { initializeLaunchDarkly } from './launchDarkly'
import runLocalizeSnippet from './localize/runLocalizeSnippet'
import logError from './logError'

const EmptyWrapper = ({ children }: { children: JSX.Element }) => children

const initializeVendors = async () => {
  try {
    // Needs to happen first to log errors from other vendors
    initializeDatadog()

    if (!isZeusEnvironment()) {
      runLocalizeSnippet()
    }

    return await initializeLaunchDarkly()
  } catch (error) {
    logError({
      message: 'Error initializing accounting suite app vendors',
      error,
    })

    // In the event that we hit an error state, return an empty wrapper
    // in place of the LaunchDarklyProvider.
    return EmptyWrapper
  }
}

export default initializeVendors
